/** Shared limits and identity projection for durable audit accepts. */

export const MAX_ACCEPT_KEY_CHARS = 2048;
export const MAX_ACCEPT_NOTE_CHARS = 280;
export const MAX_ACCEPT_BY_CHARS = 200;
export const MAX_ACCEPT_RECORDS = 5000;

export function isValidAcceptKey(value) {
  return typeof value === 'string' && value.length > 0 && value.length <= MAX_ACCEPT_KEY_CHARS;
}

/**
 * Content/collaboration identity includes the DECISION, not attribution,
 * prose, or wall-clock. Sorting also removes storage-path insertion order.
 */
export function acceptKeysForIdentity(auditAccepts) {
  if (!auditAccepts || typeof auditAccepts !== 'object' || Array.isArray(auditAccepts)) return [];
  return [
    ...new Set(
      Object.values(auditAccepts)
        .map((record) => record?.key)
        .filter(isValidAcceptKey)
    )
  ]
    .sort()
    .slice(0, MAX_ACCEPT_RECORDS);
}
